import React from 'react';
import {
  SidebarContainer,
  Icon,
  SidebarWrapper,
  UserIcon,
  HomeIcon,
  LineIcon,
  CryptoIcon,
  PieIcon,
  CardIcon
} from './AccountElements';

const SideNavbar = ({ navElement, nav }) => {
  return (
    <SidebarContainer>
      <SidebarWrapper>
        <Icon onClick={nav(0)}>
          <HomeIcon selected={navElement === 0 ? true : false} />
        </Icon>
        <Icon onClick={nav(1)}>
          <UserIcon selected={navElement === 1 ? true : false} />
        </Icon>
        <Icon onClick={nav(2)}>
          <CardIcon selected={navElement === 2 ? true : false} />
        </Icon>
        {/* <Icon onClick={nav(3)}>
          <CardIcon selected={navElement === 3 ? true : false} />
        </Icon>
        <Icon onClick={nav(4)}>
          <CryptoIcon selected={navElement === 4 ? true : false} /> */}
        {/* </Icon> */}
      </SidebarWrapper>
    </SidebarContainer >
  );
};

export default SideNavbar;
